export const SET_SUPPLIERS_STATE = 'SET_SUPPLIERS_STATE'
export const SET_SUPPLIERS_SEARCH_STATE = 'SET_SUPPLIERS_SEARCH_STATE'
export const SET_SUPPLIERS_TRACKER_STATE = 'SET_SUPPLIERS_TRACKER_STATE'
